import { render, staticRenderFns } from "./cargotype.vue?vue&type=template&id=8546e538&scoped=true&"
import script from "./cargotype.vue?vue&type=script&lang=js&"
export * from "./cargotype.vue?vue&type=script&lang=js&"
import style0 from "./cargotype.vue?vue&type=style&index=0&id=8546e538&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8546e538",
  null
  
)

export default component.exports